import { dataImageDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageDesktopSolid = /*#__PURE__*/createIcon(dataImageDesktopSolid)
export default IconImageDesktopSolid
